module.exports = __webpack_public_path__ + "img/img5-5.c048bd9b.png";